<template>
  <div
    ref="crumbContent"
    class="crumb list-crumb"
  >
    <div v-if="crumbTitle">
      <span class="crumb-title">{{ crumbTitle }}</span>
    </div>
    <div v-else>
      <div
        v-if="crumbLen>1"
        class="crumb-item go-back"
        @click="goBack(crumbLen-2)"
      >
        <span :title="$t('返回')">{{ $t('返回') }}</span><span class="separator">|</span>
      </div>
      <ul
        ref="crumbList"
        class="crumb-list"
      >
        <template v-if="PreviousNavLen">
          <li
            v-for="(item, index) in PreviousNavData"
            :key="'PreviousNav' + index"
            class="previous-nav"
          >
            <span
              class="crumb-item"
              :title="item"
              @click="goBack(index)"
            >
              {{ item }}
            </span>
            <span class="crumb-arrow">/</span>
          </li>
        </template>
        <li
          v-show="moreNav"
          class="more-nav"
        >
          <i
            class="more-nav-btn"
            @click="clickMoreBtn"
          >
            <svg class="ellipsis">
              <use xlink:href="#more" />
            </svg>
            <div
              v-show="moreNavList"
              class="more-nav-list"
              @mouseleave="moreNavList = false"
            >
              <li
                v-for="(item, index) in moreNavData"
                :key="'moreNav' + index"
              >
                <span
                  class="crumb-item more-nav-item"
                  :title="item"
                  @click.stop="goBack(index + PreviousNavLen)"
                >
                  {{ item }}
                </span>
              </li>
            </div>
          </i>
          <span class="crumb-arrow">/</span>
        </li>
        <template v-if="crumbLen">
          <li
            v-for="(item, index) in newNavData"
            :key="'newNav' + index"
          >
            <span
              class="crumb-item"
              :class="{'last-item': crumbLen === PreviousNavLen + moreNavLen + index + 1,'crumb-nav-item':index > 1 || moreNav}"
              :title="item"
              @click="goBack(index+PreviousNavLen+moreNavLen)"
            >
              {{ item }}
            </span>
            <span class="crumb-arrow">/</span>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    crumbData: Array,
    PreviousNavNum: {
      type: Number,
      default: 2,
    },
    crumbTitle: String,
  },
  data() {
    return {
      moreNav: false,
      moreNavList: false,
      PreviousNavData: [],
      moreNavData: [],
      newNavData: [],
    }
  },
  computed: {
    crumbLen() {
      return this.crumbData.length
    },
    moreNavLen() {
      return this.moreNavData.length
    },
    PreviousNavLen() {
      return this.PreviousNavData.length
    },
    newNavDataLen() {
      return this.newNavData.length
    },
  },
  watch: {
    crumbData(nv, ov) {
      if (nv != ov) {
        Object.assign(this.$data, this.$options.data())
        this.renderNav()
      }
    },
    moreNavList(val) {
      if (val) {
        document.addEventListener('click', this.blankHander)
      } else {
        document.removeEventListener('click', this.blankHander)
      }
    },
  },
  mounted() {
    this.renderNav()
  },
  methods: {
    clickMoreBtn() {
      this.moreNavList = true
    },
    goBack(index) {
      if (this.crumbLen === index + 1) return
      const param = {
        path: this.crumbData.slice(0, index + 1).join('/'),
        index,
      }
      this.$emit('crumbJump', param)
    },
    async renderNav() {
      for (let i = 0; i < this.crumbLen; i++) {
        this.newNavData.push(this.crumbData[i])
        if (this.PreviousNavLen > 0) {
          this.newNavData.pop()
        }
        const width = await this.getWidth()
        if (width.listWidth + 60 > width.contentWidth) {
          this.moreNav = true
          this.PreviousNavData = this.crumbData.slice(0, this.PreviousNavNum)
          this.moreNavData = this.crumbData.slice(this.PreviousNavNum, i)
          this.newNavData = this.crumbData.slice(i)
        }
      }
      // 保证面包屑后面能展示尽可能多的层级
      while (this.moreNav) {
        const width = await this.getWidth()
        if (width.listWidth + 60 < width.contentWidth) {
          this.newNavData.unshift(this.moreNavData.pop())
        } else {
          this.moreNavData.push(this.newNavData.shift())
          break
        }
      }
    },
    getWidth() {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          const contentWidth = this.$refs.crumbContent.offsetWidth
          const listWidth = this.$refs.crumbList.offsetWidth
          const width = {
            contentWidth,
            listWidth,
          }
          resolve(width)
        })
      })
    },
    blankHander(e) {
      e.stopPropagation()
      const event = e || window.event
      const target = event.target || event.srcElement
      if (target.getAttribute('class') && target.getAttribute('class').indexOf('more-nav-list') === -1 && e.target.getAttribute('class').indexOf('more-nav-btn') === -1) {
        this.moreNavList = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
.crumb {
  position: relative;
  height: 24px;
  line-height: 24px;
  display: inline-block;
  white-space: nowrap;
  width: 100%;
  &::after {
    content: '';
    width: 0;
    height: 0;
    display: table;
    visibility: none;
    clear: both;
  }
  .crumb-title{
    font-size: 12px;
    color: #637282;
    position: absolute;
    overflow: hidden;
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &.list-crumb {
    .go-back,
    .crumb-list,
    .crumb-list>li {
      display: inline-block;
      float: left;
    }
    .more-nav {
      position: relative;
      .more-nav-btn {
        display: inline-block;
        color: #7f7f7f;
        cursor: pointer;
        .ellipsis{
          margin-top: 2px;
          width: 20px;
          height: 20px;
        }
      }
      .more-nav-list {
        position: absolute;
        z-index: 10;
        top: 20px;
        left: 0px;
        max-width: 600px;
        max-height: 500px;
        padding: 10px 0;
        overflow: auto;
        background: #FFFFFF;
        box-shadow: 0 2px 8px 0 rgba(0,0,0,0.15);
        border-radius: 2px;
        li{
          height: 36px;
          line-height: 36px;
        }
        li:hover {
          background-color:#F0F2F6;
        }
        .more-nav-item {
          width: 100%;
          padding: 0 12px;
          font-size: 13px;
          color: #282E3D;
          white-space: nowrap;
          cursor: pointer;
          box-sizing: border-box;
        }
      }
    }
    .crumb-item{
      max-width: 165px;
      font-size: 12px;
      display: inline-block;
      color: #637282;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      cursor: pointer;
      span{
        font-size: 12px;
      }
      &.crumb-nav-item{
        max-width: 40px;
      }
      &.go-back{
        color: #1B2733;
      }
      &.last-item {
        color: #1B2733;
        cursor: default;
        & + .crumb-arrow {
          display: none;
        }
      }
    }
    .crumb-arrow {
      margin: 0 6px;
      float: right;
      color: #637282;
    }
    .separator {
      margin: 0 8px;
      vertical-align: baseline;
    }
  }
  &.search-crumb {
    .go-back,
    .search-result{
      float: left;
      height: 35px;
      line-height: 35px;
      font-size: 14px;
    }
    .go-back {
      color: #2285ff;
      span.pre {
        display: inline-block;
        cursor: pointer;
        padding-right: 8px;
      }
      span.nav-gap {
        display: inline-block;
      }
    }
    .search-result {
      margin-left: 8px;
      color: #7f7f7f;
      .strong {
        color: #343434;
        max-width: 235px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        vertical-align: bottom;
        font-weight: bold;
      }
    }
  }
}
</style>
